import { useParams } from "react-router-dom";
import * as React from "react";
import axios from "axios";
import { useQuery } from "react-query";
import { FtlRouteViewModel } from "../../Project/ViewModel/FtlRouteViewModel";
import LoadingPanel from "../../Layout/LoadingPanel";
import TextInput from "../../Layout/Inputs/TextInput";
import Row from "../../Layout/PageGrid/Row";
import Col from "../../Layout/PageGrid/Col";
import { FtlRouteCard } from "../../Project/EditProject/RightSide/FtlTab/FtlRouteCard";
import { ftlRouteUrls } from "../../URL/ApplicationUrls";
import PageHeader from "../../Layout/Header/PageHeader";

const getRouteDetailsRequest = async (routeId: number) => {
  const url = ftlRouteUrls.apiDetailsFor(routeId);
  const response = await axios.get(url);
  return response.data;
};

const TripDataRouteDetailsQueryKey = "TripDataRouteDetails";

const useTripDataRouteDetailsQuery = (routeId: number) =>
  useQuery([TripDataRouteDetailsQueryKey], () => getRouteDetailsRequest(routeId), {});

export default function RouteDetails() {
  const { routeId } = useParams();
  const query = useTripDataRouteDetailsQuery(Number(routeId));
  const { isLoading } = query;
  const ftlRoute = query.data as FtlRouteViewModel;

  const pageTitle = (routeNumber: string) => {
    return <PageHeader headerText={`FTL Route - Details ${routeNumber}`} />;
  };

  if (isLoading) {
    return (
      <>
        {pageTitle("")}
        <LoadingPanel isLoading={isLoading} />
      </>
    );
  }

  return (
    <>
      {pageTitle(ftlRoute.RouteNumber ?? "")}
      <div style={{ padding: "1.4rem" }}>
        <div style={{ marginBottom: "1.5rem" }}>
          <Row gap="25px" marginBottom="1rem">
            <Col width="16.6%">
              <div className="k-flex-20">
                <TextInput
                  label="Type"
                  name="Type"
                  type="text"
                  value={ftlRoute.RouteType}
                  readOnly
                />
              </div>
            </Col>
            <Col width="16.6%">
              <TextInput
                label="Launch Batch"
                name="RouteNumber"
                type="text"
                value={ftlRoute.LaunchBatch}
                readOnly
              />
            </Col>
          </Row>
        </div>
        <FtlRouteCard ftlRoute={ftlRoute} isReadOnly />
      </div>
    </>
  );
}
